import React from 'react';
import { FaVideo, FaHeart, FaShoppingBag } from 'react-icons/fa';

interface ProfileTabsProps {
  activeTab: 'videos' | 'liked' | 'purchased';
  onTabChange: (tab: 'videos' | 'liked' | 'purchased') => void;
}

const ProfileTabs: React.FC<ProfileTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="border-b border-gray-800">
      <div className="max-w-full mx-auto px-4 sm:max-w-4xl">
        <div className="flex flex-wrap justify-center sm:justify-start gap-4 sm:gap-8">
          <button
            onClick={() => onTabChange('videos')}
            className={`flex items-center py-2 sm:py-4 border-b-2 ${
              activeTab === 'videos'
                ? 'border-red-500 text-red-500'
                : 'border-transparent text-gray-400 hover:text-white'
            }`}
          >
            <FaVideo className="w-5 h-5 sm:w-6 sm:h-6 mr-2" />
            Videos
          </button>

          <button
            onClick={() => onTabChange('liked')}
            className={`flex items-center py-2 sm:py-4 border-b-2 ${
              activeTab === 'liked'
                ? 'border-red-500 text-red-500'
                : 'border-transparent text-gray-400 hover:text-white'
            }`}
          >
            <FaHeart className="w-5 h-5 sm:w-6 sm:h-6 mr-2" />
            Liked
          </button>

          <button
            onClick={() => onTabChange('purchased')}
            className={`flex items-center py-2 sm:py-4 border-b-2 ${
              activeTab === 'purchased'
                ? 'border-red-500 text-red-500'
                : 'border-transparent text-gray-400 hover:text-white'
            }`}
          >
            <FaShoppingBag className="w-5 h-5 sm:w-6 sm:h-6 mr-2" />
            Purchased
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileTabs;
